import { ButtonLink } from '@app/components/base/ButtonLink';
import { youtubeCuepointsMessages } from '@app/modules/youtube/screens/cuepoints/messages/youtube-cuepoints-messages';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import { Alert, AlertTitle, Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface Props {
  stationId: string;
}

/**
 * Connected-state manage actions for YouTube social export (e.g. cuepoints list).
 */
export function YoutubeFeatureManage({ stationId }: Props) {
  return (
    <Box mt={2}>
      <Alert severity="info">
        <AlertTitle sx={{ mb: 2 }}>
          <FormattedMessage {...youtubeCuepointsMessages.manageCuepointsAlertTitle} />
        </AlertTitle>
        <ButtonLink
          variant="outlined"
          color="inherit"
          size="small"
          to={`/admin/youtube/cuepoints/${stationId}`}
          startIcon={<AdsClickIcon />}
        >
          <FormattedMessage {...youtubeCuepointsMessages.manageCuepoints} />
        </ButtonLink>
      </Alert>
    </Box>
  );
}
